import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

export const AutocompleteFilterSelector = ({ item, applyValue, options, label, placeholder }) => {
  const handleFilterChange = (event, newValue) => {
    applyValue({ ...item, value: newValue });
  };

  return (
    <Autocomplete
      size="small"
      options={options}
      value={item.value}
      onChange={handleFilterChange}
      renderInput={params => <TextField {...params} variant="outlined" label={label} placeholder={placeholder} />}
      sx={{ width: 190 }}
    />
  );
};
